import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

type QuoteRequestArchived = ClientInferRequest<
  typeof contract.quoteRequests.updateArchived
>["body"]["archived"];

type UpdateArchivedQuoteRequestDto = ClientInferResponseBody<
  typeof contract.quoteRequests.updateArchived
>;

type UpdateArchivePayload = {
  id: string;
  archived: QuoteRequestArchived;
};

export const updateArchiveQuoteRequest = async ({
  id,
  archived,
}: UpdateArchivePayload): Promise<UpdateArchivedQuoteRequestDto | null> => {
  const response = await api.quoteRequests.updateArchived.mutation({
    body: { archived },
    params: {
      id,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
